import apiDirectors from '../api/directors'
import apiBrokers from '../api/brokers'
import apiNews from '../api/news'
import apiLands from '../api/terrains'
import apiImi from '../api/imi'

export const actionTypes = {
  RECEIVE_DIRECTORS: 'terrains/RECEIVE_DIRECTORS',
  RECEIVE_BROKERS: 'terrains/RECEIVE_BROKERS',
  RECEIVE_NEWS: 'terrains/RECEIVE_NEWS',
  RECEIVE_LAND_USES: 'terrains/RECEIVE_LAND_USES',
  RECEIVE_IMIS: 'terrains/RECEIVE_IMIS'
}

export const loadDirectorsBySector = (id) => {
  return(dispatch, getStore) => {
    apiDirectors.fetchDirectorsBySector(id)
      .then((data) => dispatch(receiveDirectors(data)))
  }
}

function receiveDirectors(APIdata) {
  return {
    type: actionTypes.RECEIVE_DIRECTORS,
    data: APIdata.data
  }
}

export const loadBrokers = (id) => {
  return(dispatch, getStore) => {
    apiBrokers.fetchBrokers(id)
      .then((data) => dispatch(receiveBrokers(data)))
  }
}

function receiveBrokers(APIdata) {
  return {
    type: actionTypes.RECEIVE_BROKERS,
    data: APIdata.data
  }
}

export const loadNewsBySector = (id) => {
  return(dispatch, getStore) => {
    apiNews.fetchNewsBySector(id)
      .then((data) => dispatch(receiveNews(data)))
  }
}

function receiveNews(APIdata) {
  return {
    type: actionTypes.RECEIVE_NEWS,
    data: APIdata
  }
}

export const retriveLandUses = () => {
  return(dispatch, getStore) => {
    apiLands.fetchLands()
      .then((data) => dispatch(receiveLandUses(data)))
  }
}

function receiveLandUses(APIdata) {
  return {
    type: actionTypes.RECEIVE_LAND_USES,
    data: APIdata
  }
}

export const loadImisBySector = (id) => {
  return(dispatch, getStore) => {
    apiImi.fetchImisBySector(id)
      .then((data) => dispatch(receiveImis(data)))
  }
}

function receiveImis(APIdata) {
  return {
    type: actionTypes.RECEIVE_IMIS,
    data: APIdata.data
  }
}


// WEBPACK FOOTER //
// ./src/actions/terrains.js